/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fields/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Description from './Description/index'
import Number from './Number/index'
import React from 'react'
import Type from './Type/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Fields({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/Phone/Fields"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Fields.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Fields.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pr-1-2tX3iC': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Number
  viewPath={`${viewPath}/Number`}
/>
</div>
<Description
  viewPath={`${viewPath}/Description`}
/>
</div>
{children}
</React.Fragment>)
}